import { lazy } from 'react';
import PasswordContextProvider from '../contexts/PasswordContext';

const requestConfig = [
  {
    index: true,
    component: lazy(() => import('../routes/requestor/DocumentRequesting')),
    wrapper: PasswordContextProvider,
  },
  {
    path: 'new-request',
    component: lazy(() => import('../routes/requestor/NewRequest')),
  },
  {
    path: 'update-request/:id',
    component: lazy(() => import('../routes/requestor/UpdateRequest')),
  },
  {
    path: 'returned-requests',
    component: lazy(() => import('../routes/requestor/returned/ReturnedDocument')),
  },
  {
    path: 'transaction-request',
    component: lazy(() => import('../routes/requestor/new/TransactionRequest')),
  },
];

const managersChequeRequestConfig = [
  {
    index: true,
    component: lazy(() => import('../routes/requestor/managers-cheque/DocumentManagersChequeRequesting')),
    wrapper: PasswordContextProvider,
  },
  {
    path: 'new-request',
    component: lazy(() => import('../routes/requestor/NewRequest')),
  },
  {
    path: 'update-request/:id',
    component: lazy(() => import('../routes/requestor/UpdateRequest')),
  },
  {
    path: 'returned-requests',
    component: lazy(() => import('../routes/requestor/returned/ReturnedDocument')),
  },
  {
    path: 'transaction-request',
    component: lazy(() => import('../routes/requestor/new/TransactionRequest')),
  },
];

export { managersChequeRequestConfig };

export default requestConfig;
